export const SOCKET_STATES = { connecting: 0, open: 1, closing: 2, closed: 3 }
export const DEFAULT_TIMEOUT = 10000
export const WS_CLOSE_NORMAL = 1000
